<div class="tab-panel tab-panel--runs" [class.tab-panel--compact]="!isExpanded">
  <div class="detail-list">
    <div class="detail-row detail-row--runs-table">
      <div class="detail-row__label">
        <div>
          <span>Run Summary</span>
          @if (isLoading) {
          <span class="runs-pane-status">Loading…</span>
          } @else if (lastError) {
          <span class="runs-pane-error">{{ lastError }}</span>
          }
        </div>
      </div>
      <div class="detail-row__value">
        @if (!isLoading && rows.length === 0 && !lastError) {
        <div class="runs-pane-empty">No runs to display for this test.</div>
        } @else {
        <div class="runs-table-card">
          <div class="runs-table-header">
            <button
              pButton
              type="button"
              class="p-button-text p-button-sm runs-table-toggle"
              [icon]="isExpanded ? 'pi pi-arrow-right' : 'pi pi-arrow-left'"
              [attr.aria-label]="isExpanded ? 'Collapse panel' : 'Expand panel'"
              (click)="toggleTableExpanded()"></button>
          </div>
          <div class="runs-table-body" [class.runs-table-body--collapsed]="!isExpanded" (click)="onCollapsedAreaClick()">
      <app-node-summary-table
        [rows]="rows"
        [frozenColumns]="frozenColumns"
        [scrollableColumns]="scrollableColumns"
        [tableMinWidth]="tableMinWidth"
        [sortField]="sortField"
        [sortOrder]="sortOrder"
        [showTypeCellToggler]="isExpanded"
        [showAddChildButton]="false"
        [showWikiEditButton]="false"
        [reorderableColumns]="false"
        [resizableColumns]="false"
        [selectionMode]="null"
        [inlineEditEnabled]="isExpanded"
        [isRowInlineEditable]="isRowEditable"
        [scrollHeight]="''"
        (cellEdit)="onCellEdit($event)"
        (sortChange)="onSortChange($event)">
      </app-node-summary-table>
    </div>
  </div>
  }
</div>
    </div>
  </div>
</div>
